import { HABIT_PACK_OPTION } from 'constants/general';
import { useMemo, useState } from 'react';
import { t } from 'services/i18n.service';
import { useAppSelectorShallow } from 'store/hooks';
import SegmentedControl from 'components/ui/SegmentedControl';
import BrowseMorePacks from './BrowseMorePacks';
import HabitPackItems from './HabitPackItems';
import { packListsSelector } from 'store/reducer/habit-pack/selectors';
import { getPackIds } from 'utils/helpers';
import { SkeletonHabitPackList } from '../../skeleton-routine';

export default function PackLists() {
  const [activeSegment, setActiveSegment] = useState(
    HABIT_PACK_OPTION.FEATURED
  );
  const segmentOptions = [
    { value: HABIT_PACK_OPTION.FEATURED, label: t('market.featured_packs') },
    { value: HABIT_PACK_OPTION.INSTALLED, label: t('market.installed_packs') }
  ];
  const { installedHabitPacks, featuredHabitPacks, areHabitPacksLoading } =
    useAppSelectorShallow(packListsSelector);

  const installedPackIds = getPackIds(installedHabitPacks);

  const featuredHabitPacksToDisplay = featuredHabitPacks.filter(
    ({ id }) => !installedPackIds.includes(id)
  );

  const showInstalled = activeSegment === HABIT_PACK_OPTION.INSTALLED;

  const { habitPacks, packType } = useMemo(() => {
    return {
      habitPacks: showInstalled
        ? installedHabitPacks
        : featuredHabitPacksToDisplay,
      packType: showInstalled
        ? HABIT_PACK_OPTION.INSTALLED
        : HABIT_PACK_OPTION.FEATURED
    };
  }, [showInstalled, installedHabitPacks, featuredHabitPacksToDisplay]);

  return (
    <div className='w-full h-full flex flex-col ~gap-2/4 py-3'>
      <SegmentedControl
        options={segmentOptions}
        value={activeSegment}
        onChange={setActiveSegment}
        className='shadow-md w-fit'
      />

      <div className='w-full flex flex-col md:flex-row md:flex-nowrap md:justify-between ~gap-4/2 flex-1 min-h-0 '>
        {areHabitPacksLoading ? (
          <SkeletonHabitPackList />
        ) : (
          <HabitPackItems habitPacks={habitPacks} packType={packType} />
        )}
      </div>
      <BrowseMorePacks />
    </div>
  );
}
